export const formatRelativeTime = (
    isoDate: string | null,
): string => {
    if (!isoDate) return "\u2014";
    const date = parseUTCDate(isoDate);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();

    if (diffMs < 0) {
        const absDiffMs = -diffMs;
        const futureMins = Math.floor(absDiffMs / (1000 * 60));
        const futureHours = Math.floor(absDiffMs / (1000 * 60 * 60));
        const futureDays = Math.floor(absDiffMs / (1000 * 60 * 60 * 24));

        if (futureMins < 1) return "now";
        if (futureMins < 60) return `in ${futureMins}m`;
        if (futureHours < 24) return `in ${futureHours}h`;
        return `in ${futureDays}d`;
    }

    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMins < 1) return "now";
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    return `${diffDays}d ago`;
};

export const formatBytes = (
    bytes: number,
): string => {
    if (bytes === 0) return "0 B";
    const base = 1024;
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    const idx = Math.floor(Math.log(bytes) / Math.log(base));
    return parseFloat((bytes / Math.pow(base, idx)).toFixed(1)) + " " +
        sizes[idx];
};

// sqlite datetime('now') stores UTC without Z suffix ('2026-02-06 09:31:58')
// js new Date() treats ambiguous timestamps as local time, not UTC
// this normalizes to ISO 8601 with Z suffix for correct UTC interpretation
export const parseUTCDate = (dateString: string): Date => {
    // a string already carrying Z or a numeric offset (postgres text form
    // ends "+00") must not gain a second zone marker
    const hasZone = /(?:Z|[+-]\d{2}(?::?\d{2})?)$/.test(dateString);
    if (hasZone) return new Date(dateString);
    return new Date(`${dateString.replace(" ", "T")}Z`);
};

export const formatDuration = (totalSeconds: number): string => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    if (hours > 0) {
        return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
};

export const formatHour = (hour: number): string => {
    if (hour === 0) return "12 AM";
    if (hour === 12) return "12 PM";
    return hour < 12 ? `${hour} AM` : `${hour - 12} PM`;
};

export const formatHourShort = (hour: number): string => {
    if (hour === 0) return "12a";
    if (hour === 12) return "12p";
    return hour < 12 ? `${hour}a` : `${hour - 12}p`;
};
